<template>
  <!-- NOTIFICATIONS -->
  <div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <a-badge :count="size" :overflow-count="9" class="ml-3 mr-6 mt-2">
        <feather-icon icon="BellIcon" svg-classes="text-primary" class="cursor-pointer"/>
      </a-badge>

      <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

        <div class="notification-top text-center p-2 bg-primary text-white">
          <h3 class="text-white">{{ size || "0" }} New</h3>
          <div class="opacity-75">Notifications</div>
        </div>
        <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
          <ul class="bordered-items">
            <li v-for="(ntf,index) in unreadNotifications.slice(0,50)"
                :key="index"
                class="flex justify-between px-4 py-4 notification cursor-pointer"
            >
              <div class="flex items-start">
                <feather-icon icon="MailIcon" svgClasses="text-warning stroke-current mr-1 h-6 w-6"></feather-icon>
                <div class="mx-2" @click="modelRead(ntf)">
                  <span class="font-medium block notification-title">{{ limitTextTask(ntf.title) }}</span>
                  <small>{{ limitTextTask(ntf.description) }}</small>
                </div>
              </div>
              <div class="flex flex-col items-center">
                <a-dropdown :overlayStyle="{ zIndex: 100000 }" :trigger="['click']">
                  <feather-icon icon="MoreHorizontalIcon" svg-classes="w-5 h-5" />
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <div class="flex gap-2" @click="readNotifications(ntf)"> <!-- NOTE: Changed @click.stop to @click -->
                        <feather-icon icon="EyeIcon" svg-classes="text-warning w-4 h-4"></feather-icon>
                        <span>Mark as read</span>
                      </div>
                    </a-menu-item>
                    <a-menu-item>
                      <div class="flex gap-2" @click="deleteNotification(ntf)">
                        <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4"></feather-icon>
                        <span>Delete</span>
                      </div>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.created_at.$date) }}</small>
              </div>
            </li>
          </ul>
        </component>

        <div @click="directNotification" class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
          <span>View All Notifications</span>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>

    <a-modal title="Details" :visible="visibleRead" :footer="null" :bodyStyle="{ zIndex: 1000000 }" @cancel="visibleRead = false">
      <template v-if="tempRow">
        <a-descriptions layout="vertical" :column="2">
          <a-descriptions-item label="Title">
            {{ tempRow.title }}
          </a-descriptions-item>
          <a-descriptions-item label="Description">
            {{ tempRow.description }}
          </a-descriptions-item>
          <a-descriptions-item label="Date">
            {{ dateFormatWithHour(tempRow.created_at.$date) }}
          </a-descriptions-item>
        </a-descriptions>
      </template>
    </a-modal>
  </div>


</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from '@/axios'
import moment from 'moment'
import mixin from '@/views/mixin/mixin'

export default {
  components: {
    VuePerfectScrollbar
  },
  mixins:[mixin],
  data () {
    return {
      unreadNotifications: [],
      visibleRead: false,
      tempRow: null,
      size: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    async getunreadNotifications(){
      try{
        const {data: { data, size }} = await axios.get('/dashboard/notification/')
        this.unreadNotifications = data.sort((a,b)=> b.created_at.$date - a.created_at.$date)
        this.size = size
      }catch (e) {
        throw e
      }
    },
    elapsedTime(startTime) {
      return moment(startTime).fromNow()
    },
    modelRead(ntf) {
      this.visibleRead = true
      this.tempRow     = ntf
      this.readNotifications(ntf)
    },
    async readNotifications(item){
      try {
        if (item && item._id) {
          await axios.put('/dashboard/notification/',{ id: item._id.$oid })
          await this.getunreadNotifications()
        }
      }catch (e) {
        this.visibleRead = false
        this.$message.error('Server Error')
        throw new Error(e)
      }
    },
    async deleteNotification(item){
      try {
        await axios.delete('/dashboard/notification/',{ data: { id: [item._id.$oid] }})
        await this.getunreadNotifications()
      } catch (e) {
        this.$message.error('Server Error')
        throw new Error(e)
      }
    },
    directNotification() {
      this.$router.push({ path: '/settings', query: { setting: 'ntf' }})
    }
  },
  created() {
    this.getunreadNotifications()
  }
}

</script>
